package com.eladfinish.bible.contest.screens.monopoly.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Developed by
 * @author Elad Finish
 */

@Serializable
data class MonopolyItem(
    @SerialName("סוג") val type: String,
    @SerialName("היגד") val statement: String,
)

@Serializable
data class MonopolyQA(
    @SerialName("שאלה") val question: String,
    @SerialName("תשובה") val answer: String,
)

@Serializable
data class QuestionItemJsonKMP(
    @SerialName("שאלה") var question: String? = "",
    @SerialName("תשובה") var answer: String? = "",
)
